import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCap32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconCap32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.353 12.314 16 8.214l8.647 4.1L16 16.416zm8.218-6.11a1 1 0 0 1 .857 0l10.98 5.207a1 1 0 0 1 0 1.807L24 14.835v5.645l-.375.301-.625-.78.624.78v.001l-.003.002-.004.003-.01.008-.016.012-.018.014-.111.08a7 7 0 0 1-.399.263c-.343.212-.842.486-1.488.758C20.283 22.466 18.401 23 16 23a15 15 0 0 1-4-.532V26s-1 1-3 1-3-1-3-1v-5c0-1.306.835-2.417 2-2.83v-3.335l-3.41-1.617a1 1 0 0 1 .001-1.807zm-3.64 14.151c1.033.35 2.399.645 4.069.645 2.099 0 3.717-.466 4.8-.921a9 9 0 0 0 1.2-.609v-3.686l-5.571 2.643a1 1 0 0 1-.858 0L10 15.784v2.387a3 3 0 0 1 1.93 2.184M10 21.01V21a1 1 0 1 0-2 0v3.855c.252.08.584.145 1 .145a3.3 3.3 0 0 0 1-.145z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCap32);
